import { useEffect } from 'react';
import { ClaimContext, OnChangeClaimContext, OrderItem } from '../../types';

/**
 * Hook to automatically calculate the net value based on order items
 * Taking into account the tax if applicable
 */
export function useCalculateNetValueBasedOnOrderItems(
  isOrderItemsRequired: boolean,
  onChange: OnChangeClaimContext,
  orderItemContext: Pick<ClaimContext, 'orderItems' | 'isTaxIncluded' | 'taxRate' | 'isOrderItemTaxRate'>
) {
  const { orderItems, isTaxIncluded, taxRate, isOrderItemTaxRate } = orderItemContext;

  useEffect(() => {
    if (!isOrderItemsRequired) {
      return;
    }

    let netValue = 0;
    if (!isTaxIncluded) {
      netValue = orderItems.reduce((acc, item) => acc + calculateOrderItemNetValue(item, 0), 0);
    } else if (isOrderItemTaxRate) {
      netValue = orderItems.reduce((acc, item) => acc + calculateOrderItemNetValue(item, item.taxRate), 0);
    } else {
      netValue = orderItems.reduce((acc, item) => acc + calculateOrderItemNetValue(item, taxRate), 0);
    }

    const roundedValue = Math.round(netValue * 100) / 100;
    onChange({ netValue: roundedValue });
  }, [orderItems, isTaxIncluded, taxRate, isOrderItemsRequired, onChange, isOrderItemTaxRate]);
}

function calculateOrderItemNetValue(orderItem: OrderItem, taxRate: number | string | undefined | null) {
  const quantity = Number(orderItem.quantity) || 0;
  const unitPrice = Number(orderItem.unitPrice) || 0;
  const rate = Number(taxRate) || 0;
  const total = quantity * unitPrice;
  return total / (1 + rate / 100);
}
